export const supplierDiversityUrl = 'https://app.rangeme.com/fabfitfun';
